/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SearchDefinitionSchemaOutput } from './searchDefinitionSchemaOutput';
import type { SearchFiltersSchema } from './searchFiltersSchema';
import type { SearchRunSchema } from './searchRunSchema';

export interface SavedSearchSchema {
  id: string;
  project_id: string;
  name: string;
  description?: string | null;
  definition?: SearchDefinitionSchemaOutput;
  filters?: SearchFiltersSchema;
  result_count?: number | null;
  latest_ready_run_id?: string | null;
  latest_run?: SearchRunSchema | null;
  created_at: string;
  last_run_at?: string | null;
}
